"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordionStyles = void 0;
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../style/commons");
exports.useAccordionStyles = (0, core_1.makeStyles)(function () { return ({
    accordion: {
        border: "1px solid ".concat(commons_1.lightPink),
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    rounded: {
        borderRadius: '4px !important',
        boxShadow: 'none',
    },
    summary: {
        display: 'flex',
        paddingLeft: 24,
        height: 48,
        minHeight: 'unset',
    },
    content: {
        margin: 0,
        display: 'flex',
        width: '100%',
        alignItems: 'center',
    },
    hiddenExpandIcon: {
        visibility: 'hidden',
        margin: 0,
        padding: 0,
        width: 0,
        height: 0,
    },
    titleContainer: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    title: {
        width: '100%',
        fontWeight: 500,
        color: commons_1.darkSecondary,
        fontSize: 16,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    tag: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: 200,
    },
    startIcon: {
        display: 'flex',
        alignSelf: 'center',
        paddingRight: 8,
        '& svg': {
            fontSize: 16,
        },
    },
    expandIcon: {
        color: commons_1.brandPrimaryMaxDark,
        fontSize: 20,
        marginLeft: 12,
    },
    details: {
        padding: '16px 24px',
    },
    expanded: {
        height: 48,
        minHeight: 'unset !important',
    },
    shadow: {
        boxShadow: "0px 2px 2px 0px rgba(75, 75, 82, 0.25)",
    },
}); });
